import {
  useSelector as useSelectorOriginal,
  useDispatch as useDispatchOriginal,
  useStore as useStoreOriginal
} from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AppAction, AppState, AppStore } from '../types'

export const useSelector: <TSelected = unknown>(
  selector: (state: AppState) => TSelected,
  equalityFn?: ((left: TSelected, right: TSelected) => boolean) | undefined
) => TSelected = useSelectorOriginal

export const useDispatch: <Action extends AppAction>() => ThunkDispatch<AppState, unknown, Action> = useDispatchOriginal

export const useStore: () => AppStore = useStoreOriginal
